module.exports = __webpack_public_path__ + "img/TAS.04c46610.png";